import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../../sass/files/gallery.scss";
import "../../sass/files/review.scss";
import Carousel from "../homepage/components/review/component/ReviewCarousel";
import threeds from "../../assets/images/galleryicons/Frame 8.svg";
import zbrush from "../../assets/images/galleryicons/Frame 9.svg";
import maya from "../../assets/images/galleryicons/Frame 10.svg";
import unity from "../../assets/images/galleryicons/Frame 11.svg";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";

// TODO: swap these placeholder numbers for your real, current figures
const STATS = [
  { value: "4.9/5", label: "Average rating" },
  { value: "500+", label: "Models sculpted" },
  { value: "5 yrs", label: "In business" },
];

const TOOLS = [
  { icon: threeds, label: "3D Printing" },
  { icon: zbrush, label: "ZBrush" },
  { icon: maya, label: "Maya" },
  { icon: unity, label: "Unity" },
];

const TRUSTPILOT_PROFILE_URL = "https://www.trustpilot.com/review/3dspot.io";

const ReviewPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />

      <div className="review-page">
        {/* Hero */}
        <section className="hero gallery-section review-hero">
          <div className="hero-body">
            <p className="review-eyebrow">No AI. Hand-sculpted. Every time.</p>
            <p className="gallery-title mb-8">What Our Customers Say</p>
            <p className="gallery-subtitle review-hero-subtitle">
              Real feedback from clients who trusted us with their custom sculpts
            </p>

            <div className="review-stats-bar">
              {STATS.map((stat) => (
                <div className="review-stat" key={stat.label}>
                  <span className="review-stat-value">{stat.value}</span>
                  <span className="review-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonial carousel */}
        <section className="review-carousel-section">
          <div className="grid grid-cols-1 gap-4 items-center" id="review">
            <div className="flex items-center flex-cols">
              <Carousel />
            </div>
          </div>
        </section>

        {/* Tools / credibility strip */}
        <section className="review-tools-strip">
          <p className="review-tools-label">Sculpted using industry-standard tools</p>
          <div className="review-tools-row">
            {TOOLS.map((tool) => (
              <img key={tool.label} src={tool.icon} alt={tool.label} className="review-tool-icon" />
            ))}
          </div>
        </section>

        {/* Closing CTA */}
        <section className="review-cta-section">
          <p className="review-cta-title">Ready to get your own custom sculpt?</p>
          <div className="review-cta-buttons">
            <Link to="/guest-quote" className="review-cta-btn review-cta-btn-primary">
              Get a Free Quote
            </Link>
            <a
              href={TRUSTPILOT_PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="review-cta-btn review-cta-btn-secondary"
            >
              Read All Reviews on Trustpilot →
            </a>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default ReviewPage;